export default __webpack_public_path__ + "static/media/toto.7c5e86f4.png";